class Mulberry {
    constructor() {
        if (
            typeof Settings.services['mulberry'] !== 'undefined' &&
            Settings.services['mulberry']['enabled'] === true
        ) {
            this.isEnabled = true;
        } else {
            this.isEnabled = false;
        }
    }

    async getProductWarranty(hookData, hookName = null) {
        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve();
            }

            const offer = await mulberry.core.getWarrantyOffer({
                id: hookData.productVariant.sku,
                title: hookData.product.title,
                price: hookData.productVariant.price.amountInCents / 100,
            });

            if (!offer.length) {
                return resolve();
            }

            mulberry.modal.init({
                offers: offer,
                settings: mulberry.core.settings,
                onWarrantySelect: async warranty => {
                    const result = await mulberryShop.getWarrantyVariant(warranty);
                    const productInfo = await this.checkForMulberryProduct(
                        result.shopify_variant_id
                    );

                    // Remove Mulberry Warranty hook to break out of otherwise infinite loop.
                    if (hookName) {
                        window.vue.$store.dispatch('cart/removeHook', {
                            hook: 'addedToCart',
                            name: hookName,
                        });
                    }

                    await window.vue.$store.dispatch('cart/addVariantToCart', {
                        product: productInfo.product,
                        productVariant: productInfo,
                        customProperties: {
                            _variantId: hookData.productVariant.shopify_id,
                            _product: hookData.product.title,
                            _warranty: {
                                warranty_offer_id: warranty.warranty_offer_id,
                            },
                        },
                    });

                    mulberry.modal.close();

                    return resolve();
                },
                onWarrantyDecline: () => {
                    mulberry.modal.close();

                    return resolve();
                },
            });

            mulberry.modal.open();
        });
    }

    async checkForMulberryProduct(id) {
        return await new Promise((resolve, reject) => {
            if (!this.isEnabled) {
                return reject();
            }

            axios
                .get('/apps/mulberry/warranty/' + id)
                .then(async response => {
                    return resolve(response.data);
                })
                .catch(error => {
                    alert('Could not add warranty to cart.');
                    mulberry.modal.close();

                    return reject(false);
                });
        });
    }
}

export default new Mulberry();
